import { TypedTypePolicies } from "../graphql/apolloHelpers";

export const typePolicies: TypedTypePolicies = {
  Currency: {
    keyFields: ["code"],
  },
};
